import React from 'react';

import { useCustomTheme } from '../../../../../../../../hooks/useCustomTheme';
import { TransactionsListRowProps } from '../../../types/TransactionsListRowProps';

export const toOrderDetailFieldColumn = ({ flex }: { flex?: number }) => {
  const { palette, customBorderRadius } = useCustomTheme();
  return {
    flex: flex ?? 0.15,
    field: 'to_detail',
    sortable: false,
    headerName: ' ',
    renderCell: (rowData: TransactionsListRowProps) => {
      return rowData.row.orderId ? (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: palette.grey[100],
            width: 24,
            height: 24,
            borderRadius: customBorderRadius.button,
          }}
        >
          <i
            className="material-icons-outlined"
            style={{
              verticalAlign: 'sub',
              fontSize: '20px',
              color: palette.text.primary,
            }}
          >
            {'chevron_right'}
          </i>
        </div>
      ) : (
        <></>
      );
    },
  };
};
